import Temporal from "./Temporal";

export default class TemporalList {
  constructor(name, initialValue, namespace, startDateNameSpace, endDateNameSpace) {
    this.namespace = namespace;
    this.name = name;
    this.startDateNameSpace = startDateNameSpace;
    this.endDateNameSpace = endDateNameSpace;
    this.objList = [];
    if (initialValue) {
      this.parseInputJSON(initialValue);
    } else {
      this.addValueObj();
    }
  }

  getNameSpace() {
    return this.namespace;
  }

  getObjList() {
    return this.objList;
  }

  setObjList(fobjList) {
    this.objList = fobjList;
  }

  removeValueObj(item, index) {
    if (index < 0 || index >= this.objList.length) {
      return;
    }
    this.objList.splice(index, 1);
  }

  addValueObj(obj) {
    const objItem = new Temporal(this.name, obj, this.namespace, this.startDateNameSpace, this.endDateNameSpace);
    this.objList.push(objItem);
    // console.log("addValueObj", this.objList);
  }

  parseInputJSON(inputJSON) {
    const obj = inputJSON[this.namespace];
    // const obj = inputJSON;
    // console.log(inputJSON);
    if (Array.isArray(obj)) {
      for (const entry of Object.entries(obj)) {
        const value = entry[1];
        // console.log(value);
        this.addValueObj(value);
      }
    } else {
      // console.log(obj);
      this.addValueObj(obj);
    }
  }

  getExpandedFormatValue() {
    const expandedList = [];
    for (let index = 0; index < this.objList.length; index++) {
      const objItem = this.objList[index];
      expandedList.push(objItem.getExpandedFormatValue());
    }
    return expandedList;
  }


  isEmpty() {
    let condition = true;
    for (let index = 0; index < this.objList.length; index++) {
      const objItem = this.objList[index];
      condition = condition && objItem.isEmpty();
    }
    return condition;
  }
}
